import DashboardLayout from "Layout/DashboardLayout";
import { cn } from "utils";
import { useState } from "react";
import { ManualOrderHeader } from "./ManualOrderHeader";
import { useProducts } from "hooks/ProductsManagement/useGetProductsQuery";
import { formatCurrency } from "utils/formatNumber";
import { Separator } from "Components/Separator";
import { useDebounce } from "hooks/useDebounce";
import { useOrderCartStore } from "../useOrderCartStore";
import { ManualOrderCart } from "./ManualOrderCart";
import Loader from "Components/Loader";

export const ManualOrderManagement = () => {
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search);

  const { data, isPending } = useProducts({
    search: debounceSearch,
  });

  const products = data?.data?.docs || [];

  const setCart = useOrderCartStore((state) => state.setCart);
  const cartItems = useOrderCartStore((state) => state.cart);
  const removeCartItem = useOrderCartStore((state) => state.removeCartItem);

  return (
    <DashboardLayout title="Manual Order" className="h-[92%]" back>
      <div className="grid grid-cols-[2fr_auto_1fr] gap-x-4 mt-5">
        <div className="ml-5 mr-2 flex flex-col gap-y-6">
          <ManualOrderHeader search={search} onSearch={setSearch} />

          {isPending && <Loader />}

          <div className="grid gap-y-4 gap-x-3 grid-cols-3">
            {products.map((product) => {
              const itemExists = cartItems.some(
                (item) => item.id === product.id
              );

              return (
                <div
                  className={cn("cursor-pointer")}
                  onClick={() => {
                    if (itemExists) {
                      removeCartItem(product.id);
                    } else {
                      setCart(product);
                    }
                  }}
                  key={product.id}>
                  <img
                    src={product.images[0] || "https://via.placeholder.com/50"}
                    alt="product"
                    className={cn(
                      "w-full h-[200px] border-[0.86px] border-[#eeeeee] rounded-lg",
                      {
                        "border-primary border-[2px]": itemExists,
                      }
                    )}
                  />
                  <h3 className="mt-4 font-normal text-xs">{product.name}</h3>
                  <div className="my-2 font-semibold text-sm">
                    {formatCurrency(product.bulkPrice / 100)}
                  </div>
                  <p className="mb-1 text-xs">
                    {formatCurrency(product.unitPrice / 100)}{" "}
                    <span className="text-ash">unit price</span>
                  </p>
                  <div className="text-primary-foreground text-xs flex gap-x-1">
                    <div className=""></div>
                    <div className="">
                      {product.bulkTotalStock} Cartons left
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <Separator />

        <div className="flex gap-2 px-4">
          <ManualOrderCart />
        </div>
      </div>
    </DashboardLayout>
  );
};
